/*
 * cpap-flash.js — schedule-aware Flash Sale countdown + site-wide active-state.
 * Loaded site-wide from layout/theme.liquid.
 *
 * - <flash-schedule> renders a live countdown. When the sale window is open it counts
 *   down to the window END ("ends in"); when closed it counts down to the NEXT window
 *   START ("next sale in"). Default schedule = all-day Tuesday, Australia/Adelaide.
 * - It also toggles `flash-on` / `flash-off` on <html> so membership badges across the
 *   whole site (PLP cards, PDP, the flash collection) only show while the sale is live.
 *
 * Note: countdown diff is computed in a single "wall-clock" frame for the configured
 * timezone, so it stays correct across the user's own timezone. A DST transition that
 * lands inside the next window can shift the readout by 1h once a year — acceptable.
 */
(function () {
  var DEFAULT = { day: 2, start: '00:00', duration: 24, tz: 'Australia/Adelaide' };

  function wallNow(tz) {
    // A Date whose LOCAL fields equal the wall-clock time in `tz`.
    return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
  }

  function computeState(cfg) {
    var now = wallNow(cfg.tz);
    var parts = String(cfg.start).split(':');
    var sh = parseInt(parts[0], 10) || 0;
    var sm = parseInt(parts[1], 10) || 0;
    var start = new Date(now);
    start.setHours(sh, sm, 0, 0);
    var delta = (now.getDay() - cfg.day + 7) % 7;          // days since last target weekday
    start.setDate(start.getDate() - delta);
    if (start.getTime() > now.getTime()) start.setDate(start.getDate() - 7);
    var end = start.getTime() + cfg.duration * 3600000;
    if (now.getTime() < end) return { on: true, target: end, now: now.getTime() };
    return { on: false, target: start.getTime() + 7 * 86400000, now: now.getTime() };
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function render(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400); t -= d * 86400;
    var h = Math.floor(t / 3600); t -= h * 3600;
    var m = Math.floor(t / 60); var s = t - m * 60;
    var seg = function (v, l) { return '<span class="cd-seg"><b>' + pad(v) + '</b><i>' + l + '</i></span>'; };
    return (d > 0 ? seg(d, 'days') : '') + seg(h, 'hrs') + seg(m, 'min') + seg(s, 'sec');
  }

  function setRoot(on) {
    var r = document.documentElement;
    r.classList.toggle('flash-on', on);
    r.classList.toggle('flash-off', !on);
  }

  // Site-wide active-state from the default schedule — drives badge visibility everywhere,
  // even on pages with no <flash-schedule> element.
  function rootTick() { setRoot(computeState(DEFAULT).on); }
  rootTick();
  setInterval(rootTick, 30000);

  if (!customElements.get('flash-schedule')) {
    customElements.define('flash-schedule', class extends HTMLElement {
      connectedCallback() {
        this.cfg = {
          day: this.hasAttribute('data-day') ? parseInt(this.getAttribute('data-day'), 10) : DEFAULT.day,
          start: this.getAttribute('data-start') || DEFAULT.start,
          duration: this.hasAttribute('data-duration') ? parseFloat(this.getAttribute('data-duration')) : DEFAULT.duration,
          tz: this.getAttribute('data-tz') || DEFAULT.tz
        };
        this.out = this.querySelector('[data-cd-out]');
        this.lab = this.querySelector('[data-cd-label]');
        this.onLab = this.getAttribute('data-label-on') || 'Flash Sale ends in';
        this.offLab = this.getAttribute('data-label-off') || 'Next Flash Sale in';
        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var st = computeState(this.cfg);
        this.classList.toggle('is-on', st.on);
        this.classList.toggle('is-off', !st.on);
        this.classList.toggle('is-urgent', st.on && (st.target - st.now) <= 7200000);
        if (this.lab) this.lab.textContent = st.on ? this.onLab : this.offLab;
        if (this.out) this.out.innerHTML = render(st.target - st.now);
      }
    });
  }
})();
